import axios, {AxiosError, AxiosRequestConfig, AxiosResponse, ResponseType} from "axios";
import UyapHtmlParser from './parser/UyapHtmlParser';
import {getCachedItem, setCachedItem} from '../uyap-cache';
import {UyapRequestResponseHandler} from "./UyapRequestResponseHandler";
import app from "@/main";

const delay = (ms: number) => new Promise(res => setTimeout(res, ms));

export interface UyapPaginationResponse<T> {
    items: T[],
    currentPage: number,
    pageSize: number
}

export type RequestType = "json"|"formData"|"urlencoded";

export function isArray(data: any): boolean {
    return Array.isArray(data);
}

export function isUndefined(item: any): boolean {
    return typeof item == "undefined";
}


export abstract class UyapRequest<T, C> extends UyapRequestResponseHandler {
    axios = axios;
    ImzaClientAddr = "https://imza.eicrapro.com:6081/";
    htmlParser = UyapHtmlParser;
    message!: string;
    talepData!: T;
    delayTime: number = 3000;
    uyapSessionCounter = 0;
    timeoutTryCounter = 0;

    private static sessionRecoveryLock: Promise<void> | null = null;
    private static htmlSessionCheckInProgress: boolean = false;
    htmlRetryDone: boolean = false;

    async prepareRequestData(requestData: any): Promise<{ data: any, type: "urlencoded" | "formData" | "xml" | "json" }> {
        let data: any = requestData;
        let dataType: "urlencoded" | "formData" | "xml" | "json" = "urlencoded";
        if (typeof requestData.formData != "undefined") {
            data = requestData.data;
            dataType = "formData";
        } else if (typeof requestData.xml != "undefined") {
            data = requestData.data;
            dataType = "xml";
        } else if (typeof requestData.api != "undefined") {
            data = requestData.api;
            dataType = "json";
        }
        if(this.getRequestType() == "json"){
            data = requestData;
            dataType = "json";
        }
        return {
            data: data,
            type: dataType
        }
    }

    getHeaders(data: any) {
        let jsessionId = window.sessionStorage.getItem("JSESSIONID");
        let headers = {
            // "Token": jsessionId,//"JSESSIONID=0000Say0hve3UknBteFAizqT4Xt:1e3ae09ie",
            "Content-Type": "application/x-www-form-urlencoded"
        };
        if (typeof data != "undefined" && typeof data.formData != "undefined")
            headers["Content-Type"] = "multipart/form-data";
        if (typeof data != "undefined" && typeof data.xml != "undefined")
            headers["Content-Type"] = "application/xml;charset=UTF-8";
        if (typeof data != "undefined" && typeof data.api != "undefined")
            headers["Content-Type"] = "application/json;charset=UTF-8";
        //TODO GETREQUEST TYPE EKLENDI ABSTRACT BURALAR OPTİMİZE EDİLECEK STANDART OLACAK SUAN ZAMAN YOK
        if (typeof data != "undefined" && this.getRequestType() == "json")
            headers["Content-Type"] = "application/json;charset=UTF-8";
        return headers;
    }

    showSpinnerMessage(){
        //@ts-ignore
        if(typeof app.$spinner != "undefined"){
            //@ts-ignore
            app.$spinner.message(this.getSpinnerMessage(),this.getTimeoutSeconds());
        }
    }

    hideSpinnerMessage(){
        //@ts-ignore
        if(typeof app.$spinner != "undefined"){
            //@ts-ignore
            app.$spinner.hide();
        }
    }

    async execute(data: T): Promise<AxiosResponse> {
        try{
            this.timeoutTryCounter++;
            let requestPayload = await this.prepareRequestData(data);
            let response;
            let axiosConfig = {
                url: this.getUrl(),
                method: this.getMethod(),
                headers: this.getHeaders(data),
                responseType: this.getResponseType(data),
                withCredentials: true,
                timeout: this.getTimeoutSeconds() * 1000
            } as AxiosRequestConfig;
            this.showSpinnerMessage();

            if (app.$store.getters.isEicraproDevMode) {
                await delay(this.delayTime);
                response = {
                    statusText: "OK",
                    status: 200,
                    data: this.getMockResponse(),
                } as AxiosResponse;
            } else {
                //let params =  new URLSearchParams(data)
                switch (this.getMethod()) {
                    case "GET":
                        axiosConfig.params = requestPayload.data;
                        break;
                    case "POST":
                        if (requestPayload.type == "formData") {
                            axiosConfig.data = requestPayload.data;
                        }
                        else if(requestPayload.type == "json"){
                            axiosConfig.data = JSON.stringify(requestPayload.data);
                        }
                        else {
                            axiosConfig.data = this.serialize(requestPayload.data);
                        }
                        break;
                }
                response = await this.axios(axiosConfig);
                /*let delayTime = defaultDelayTime;
                if(typeof this.getDelayTime() != "undefined"){
                    delayTime = this.getDelayTime();
                }
                 */
                await delay(this.delayTime);
            }
            this.hideSpinnerMessage();
            return response;
        }catch (error) {
            if(error.response?.status == 401)
                return  this.uyapSessionCheck(data);
            if(error.response?.status == 504){
                if(this.timeoutTryCounter <= 3 ){
                    app.$toast.warning("Uyap'a gönderilen istek zaman aşımına uğradı tekrar deneniyor...");
                    await delay(1000);
                    return this.execute(data);
                }
                this.timeoutTryCounter = 0;
                throw new Error(error.message);
            }

            throw new Error(error.message);
        }
    }

    serialize(obj: any) {
        let str = [];
        for (let p in obj)
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        return str.join("&");
    }

    public async isDataCached(data: T): Promise<boolean> {
        this.talepData = data;
        let cacheArgs = this.cache();
        if (cacheArgs) {
            let cachedData = await getCachedItem<C>(cacheArgs.key);
            return !!cachedData;
        }
        return false;
    }

    public run(data: T): Promise<C> {
        return new Promise<C>(async (resolve, reject) => {
            this.talepData = data;
            this.uyapSessionCounter++;
            console.log("this.uyapSessionCounter",this.uyapSessionCounter);
            let cacheArgs = this.cache();
            if (cacheArgs) {
                let cachedData = await getCachedItem<C>(cacheArgs.key);
                if (this.cache().active === true &&cachedData) {
                    //console.log("RETURNED FROM CACHE STORAGE " + cacheArgs.key, cachedData);
                    let parsedResult = await this.parse(cachedData);
                    return resolve(parsedResult);
                }
            }
            this.talepData = data;
            this.execute(data).then((response: AxiosResponse) => {
                this.prepareResponseData(data,response).then((preparedResponse: AxiosResponse) => {
                    //console.log("PREPARED DATA",preparedResponse);
                    if (preparedResponse.data.error && preparedResponse.data.error != "" && preparedResponse.data.errorCode && preparedResponse.data.errorCode != "")
                        return reject(preparedResponse.data);
                    this.parse(preparedResponse.data).then(async (result: C) => {
                        if (cacheArgs && cacheArgs.active === true)
                            await setCachedItem(cacheArgs.key, preparedResponse.data, cacheArgs.ttl);
                        return resolve(result);
                    }).catch((err: Error) => {
                        return reject(err);
                    })
                }).catch(preparedError => {
                    return reject({message: preparedError.message});
                });
            }).catch(async (err: AxiosError) => {
                return reject(err);
            });
        })
    }

    async prepareResponseData(requestData: any , data: AxiosResponse): Promise<AxiosResponse> {
        try {
            if (app.$store.state.eicraproDevMode == false) {
                data = await this.tryForBlob(data);
                //console.log("this.getUrl() != this.ImzaClientAddr)",this.getUrl().substr(0,this.ImzaClientAddr.length) , this.ImzaClientAddr);

                /**
                 * Not: Makbuz indirirken file html olarak geliyor fakat bazen yetkiniz yoktur diye html olarak bi metin geliyorbunu handle etmek  için
                 * burada content dispotion kontrolü yapılıp response içindeki metin throw olarak veriliyor buraya elleme bilgin yoksa emre.- abdullah
                 */

                if (typeof data.headers["content-disposition"] == "undefined" &&
                    data.headers["content-type"] &&
                    data.headers["content-type"].includes("text/html") &&
                    this.getUrl().substr(0,this.ImzaClientAddr.length) == this.ImzaClientAddr){
                    // status 200 ama login sayfası gelmesi durumunda oturum kontrolü ve tekrar isteği atma koşulu
                    if (!this.htmlRetryDone && !UyapRequest.htmlSessionCheckInProgress) {
                        this.htmlRetryDone = true;
                        UyapRequest.htmlSessionCheckInProgress = true;
                        try {
                            await app.$uyap.AvukatKisiselBilgileriSorgulama().run({});
                            // Session geçerli, UYAP anlık hata — isteği bir kere daha at
                            UyapRequest.htmlSessionCheckInProgress = false;
                            const retryResponse = await this.execute(requestData);
                            return this.prepareResponseData(requestData, retryResponse);
                        } catch (_) {
                            // Session düşmüş — mevcut recovery mekanizmasını kullan
                            UyapRequest.htmlSessionCheckInProgress = false;
                            return this.uyapSessionCheck(requestData, "prepareResponseData");
                        }
                    }
                    if(data.data instanceof Blob){
                        throw new Error(await data.data.text())
                    }
                    throw new Error(data.data);
                }
            }
            //this.sessionControl(data);
            data = await this.tryForXml(data);
            data = await this.tryForJson(data);
            return data;
        } catch (e) {
            console.log("error > prepareResponseData ", e);
            // @ts-ignore
            if (e.message == "nosessionobject"
                || e.message == "En fazla 5 aktif oturum açabilirsiniz! " //PRTL_GNL_100026-1
                /*|| e.message == "Yapılmak istenen işlem sırasında hata oluştu. "*/) {
                return await this.uyapSessionCheck(requestData, "prepareResponseData");
            }
            // @ts-ignore
            throw new Error(e.message);
        }
    }

    private waitForSessionRecovery(): Promise<void> {
        return new Promise((resolve, reject) => {
            const defaultTryTime = 15;
            let trykey = 0;
            app.$socket.client.emit('connectToUyap');
            const interval = setInterval(() => {
                trykey++;
                if (app.$store.getters.isUyapConnected === true) {
                    clearInterval(interval);
                    UyapRequest.sessionRecoveryLock = null;
                    return resolve();
                }
                if (trykey >= defaultTryTime) {
                    clearInterval(interval);
                    return reject(new Error("Oturum Düştü Tekrar Oturum Açılamadı !"));
                }
            }, 1000);
        });
    }

    private runSessionRecovery(): Promise<void> {
        console.log("UyapRequest.sessionRecoveryLock",UyapRequest.sessionRecoveryLock);
        if (UyapRequest.sessionRecoveryLock) {
            return UyapRequest.sessionRecoveryLock;
        }
        UyapRequest.sessionRecoveryLock = this.waitForSessionRecovery();
        return UyapRequest.sessionRecoveryLock;
    }

    uyapSessionCheck(requestData: any, from: "execute" | "prepareResponseData" = "execute"): Promise<AxiosResponse> {
        return this.runSessionRecovery().then(async () => {
            const responseData = await this.execute(requestData);
            if (from === "execute") {
                return responseData;
            }
            return this.prepareResponseData(requestData, responseData);
        });
    }


    protected getResponseType(data: any): ResponseType {
        if (typeof data != 'undefined' && typeof data.download != 'undefined') {
            return 'blob';
        }
        return 'text';
    }

    protected getRequestType(): RequestType {
        return "urlencoded";
    }

    protected getSpinnerMessage(): string {
        return "";
    }

    protected getTimeoutSeconds(): number {
        return 30;
    }

    protected abstract getUrl(): string;


    protected abstract getMockResponse(): string | any;

    protected abstract getMethod(): 'POST' | 'GET';

    //protected abstract getDelayTime():number;
    protected abstract cache(): { active: boolean, ttl: number, key: string }

    protected abstract parse(data: string | Blob | any): Promise<C>;


}


